<template>
    <v-row v-if="searchConfig && searchConfig.length>0" style="margin-top:22px; margin:10px">
        <v-col cols="2" v-for="(item, index) in searchConfig" :key="index" ref="filters">
            <TextFilter v-if="item.source === 'text'" :config="item" :context="searchContext" v-on:change="onFilterChange"></TextFilter>
            <DateFilter v-if="item.source === 'date'" :config="item" :context="searchContext" v-on:change="onFilterChange"></DateFilter>
            <SelectFilter v-if="item.source === 'select'" :config="item" :context="searchContext" v-on:change="onFilterChange"></SelectFilter>
            <SwitchFilter v-if="item.source === 'boolean'" :config="item" :context="searchContext" v-on:change="onFilterChange"></SwitchFilter>
        </v-col>
    </v-row>
</template>
 
 <script> 
import TextFilter from './filter/TextFilter'
import DateFilter from './filter/DateFilter'
import SelectFilter from './filter/SelectFilter'
import SwitchFilter from './filter/SwitchFilter'

 export default {
   name: 'SearchPanel',
   props: ['config','context'],
   components: { 
    TextFilter, DateFilter, SelectFilter, SwitchFilter
   },
   data() {
       return {
            searchConfig: [],
            searchContext: {},
            //frefs: [],
       }
   },
    mounted() {
        this.searchConfig = this.config.search;
    },
		watch: {
       context: function() { 
        const me = this;
				setTimeout(() => {
          me.searchContext = me.context;
        }, 400); 
				//this.searchContext = this.context;
      },
      config: function(config) { 
        this.searchConfig = config.search;
    }
     },
    methods: {
        onFilterChange() {
            let currentFilters = [];
            for (let pos=0;pos<this.searchConfig.length;pos++) {
                const filter = this.$refs.filters[pos].firstElementChild.__vue__.$parent; //TODO: REVISAR
                let value = filter.getValue?filter.getValue():null;
								if (value) {
                    currentFilters.push({
                        fields: this.searchConfig[pos].fields,
                        type: this.searchConfig[pos].type,
                        value: this.getValue(this.searchConfig[pos].type, value) 
                    });
                }
            }

           this.$emit ('change', currentFilters);
        },
				getValue(type, value) {
					if (type !== 'boolean')
						return value;
					return value === 'true' ? 1 : 0;
				}
    }
 };
 </script>
  